import React from "react";
import { PageHero } from "@/components/site/PageHero";
import { Seo } from "@/components/site/Seo";

const CONTENT = {
  privacy: {
    title: "Privacy",
    intro: "How we handle your information.",
    body: [
      "Psalm 30:2 Chiropractic respects your privacy. This website collects only the information needed to operate the site and respond to enquiries. Booking is handled through our third-party scheduling provider (Jane), which maintains its own privacy practices.",
      "We design our systems around applicable healthcare privacy and security expectations. Sensitive health information is never displayed in general analytics, and we limit access to information on a least-privilege basis.",
      "This is placeholder legal copy to be reviewed and finalized with appropriate counsel before launch.",
    ],
  },
  terms: {
    title: "Terms",
    intro: "Terms of use for this website.",
    body: [
      "The content on this website is provided for general educational purposes and does not constitute medical advice, a diagnosis, or a guarantee of any particular outcome. Individual results vary.",
      "Always consult a qualified healthcare professional regarding your specific situation. Suitability for any treatment is determined only through individual assessment.",
      "This is placeholder legal copy to be reviewed and finalized with appropriate counsel before launch.",
    ],
  },
  accessibility: {
    title: "Accessibility",
    intro: "Our commitment to an accessible experience.",
    body: [
      "We are building toward WCAG 2.2 AA. This includes keyboard navigation, visible focus states, sufficient color contrast, semantic headings, alternative text for imagery, labeled forms, and support for reduced-motion preferences.",
      "If you encounter any barrier using this website, please contact us and we will work to provide the information you need in an accessible format.",
    ],
  },
};

export default function Legal({ kind }) {
  const c = CONTENT[kind] || CONTENT.privacy;
  return (
    <div>
      <Seo title={`${c.title} | Psalm 30:2 Chiropractic`} description={c.intro} />
      <PageHero eyebrow="Legal" title={c.title} intro={c.intro} />
      <section className="bg-ivory pb-28 px-6">
        <div className="max-w-2xl mx-auto prose-editorial text-lg font-light text-espressosoft/85">
          {c.body.map((p, i) => <p key={i}>{p}</p>)}
        </div>
      </section>
    </div>
  );
}
